<div
  ngClass="{{type == 'doughnut'? 'sm:flex items-center': ''}} {{type == 'pie'? 'sm:flex items-center': ''}}">
  @if (isBrowser) {
  <p-chart [type]="type" [data]="data" [options]="options" [height]="height" [width]="width"></p-chart>
  }

  @if((type === 'doughnut' || type === 'pie') && isBrowser) {
  <div class="ms-4" style="max-height: 200px; overflow-y: auto;">
    <div class="flex items-start mb-1 pe-2" *ngFor="let data of legendData">
      <div class="me-2 mt-1" [style.background]="data.color" style="min-width: 10px; min-height: 10px;"></div>
      <app-typography variant="extraSmall">
        {{ data.value }}
      </app-typography>
    </div>
  </div>
  }
</div>